import Dexie from "dexie";
import * as mod from '../model'
// import {exportDB, importDB, importInto} from "dexie-export-import";
import {exportDB, importDB, importInto} from "../src/lib/dexie-export-import";
// import 'dexie-observable';
import {ipcInvoke} from "@/common/ipc";
import {DEBUG} from "@/electron_interactive";

var db:any;
let mUpdateTime = 0;


export function initModel(){
    if (DEBUG){
        Dexie.debug = true;
    }

    db = new Dexie("note");
    db.version(62).stores({
        doc: '&id',
        // img: '&id,data',
        note: '&id,*name,*folderId,*tags,*createTime,*isDeleted,deleteTime,*isFavirated,*updateTime,*viewTime',
        sysconfig:'&key,value',
        publishNote:'&id',
        folder:'&id',
        pageCache:'&id',
        fontInfo:'&id',
        card:'&id,*name,*type,*isDeleted,[type+isDeleted],*tags,*isFavirated,*createTime,*updateTime,*isHidden,[isDeleted+isHidden],*formatDate,[type+formatDate],*viewTime,*libraryId',
        cardDoc:'&id',
        tag:'++id,&name,*updateTime,*isFavirated,*groupId',
        group:'++id,&name,*createTime,*updateTime,*isFavirated',
        highlight:'&id,*name,*createTime,*updateTime',
        libraryHistory:'++id,*libraryId,*historyTime',
        projectHistory:'++id,*projectId,*historyTime',
        projectHistoryDoc:'&id,*projectId',
        projectBoard:'&id,*isFavirated,*tags',
        cardLinkCache:'&id',
        customFilter:'&id,*isFavirated',
        favorFolder:'&id',
        projectContentFilter:'&id',
        link:'&id,*isFavirated',//收藏的自定义链接...
        property:'&id,*name,*updateTime,*groupName',
        view:'&id,*tagName',
        webHistory1:'&id,*url,*isFavor',
        tiptapDoc:'&id',
        transcript:'&id',
        template:'&id,name,content,createTime,updateTime',

    });

    // db.on('changes',(changes)=>{
    //     if (changes?.length > 0){
    //         if (Date.now() - mUpdateTime > 3000){
    //             ipcInvoke('update-backup-time');
    //             mUpdateTime = Date.now();
    //         }
    //     }
    // });

    // 监听数据库关闭事件
    db.on('close', () => {
        console.warn('数据库连接已关闭');
    });


    db.open();

    mod.initNote(db)
    mod.initDoc(db)
    mod.initSysConfig(db);
    mod.initPublishNote(db);
    mod.initFolder(db);
    mod.initPageCache(db);
    mod.initFontInfo(db);
    mod.initCard(db);
    mod.initTag(db);
    mod.initHighlight(db);
    mod.initLibraryHistory(db);
    mod.initProjectHistory(db);
    mod.initBoard(db);
    mod.initCardlinkCache(db);
    mod.initCustomFilter(db);
    mod.initFavorFolder(db);
    mod.initProjectContentFilter(db);
    mod.initLink(db);
    mod.initProperty(db);
    mod.initView(db);
    mod.initWebHistory(db);
    mod.initTranscript(db);
    mod.initTiptapDoc(db);
    mod.initTemplate(db);
}

/**
 * 重新打开数据库
 */
export function reOpenDb(){
    db.open();
}

function subscriptionChanges(changes){
    if (changes?.length > 0){
        if (Date.now() - mUpdateTime > 3000){
            ipcInvoke('update-backup-time');
            mUpdateTime = Date.now();
        }
    }
}

export async function disconnectObservable(){
    // db.on('changes').unsubscribe();
    //清空几个记录表
    await db._changes.clear();
    await db._intercomm.clear();
    await db._syncNodes.clear();
    await db._uncommittedChanges.clear();
}

export function reconnectObservable(){
    // db.on('changes',subscriptionChanges);
}

export async function exportDb(progressCallback:any){
    const blob = await exportDB(db, {progressCallback});
    return blob;
}

export function importDb(blob:Blob,progressCallback:any){
    return importInto(db,blob,{
        clearTablesBeforeImport:true,
        chunkSizeBytes:512*1024,
        overwriteValues:true,
        acceptVersionDiff:true,
        acceptMissingTables:true,
        skipTables:['_changes','_intercomm','_syncNodes','_uncommittedChanges'],
        progressCallback:progressCallback
    });
}

/**
 * 不清除数据直接恢复
 * @param blob
 * @param progressCallback
 */
export function restoreDbNoClear(blob:Blob,progressCallback:any){
    return importInto(db,blob,{
        clearTablesBeforeImport:false,
        chunkSizeBytes:512*1024,
        overwriteValues:true,
        acceptVersionDiff:true,
        acceptMissingTables:true,
        skipTables:['_changes','_intercomm','_syncNodes','_uncommittedChanges'],
        progressCallback:progressCallback
    });
}




































